import { combineReducers } from 'redux';
import allDealsReducer from './AllDeals/allDealsReducer';
import authReducer from './Auth/authReducer';

const rootReducer = combineReducers({
   allDeals: allDealsReducer,
   auth: authReducer
});

export default rootReducer;